import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getStatus } from "@/store/slices/helpers/helpers";
import { clearData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiUrls } from "@/store/api/constants";

export default function useOnActions() {
  const [isAlertDialog, setIsAlertDialog] = useState(false);

  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const state = useSelector((store) => store);
  const [currentRowId, setCurrentRowId] = useState(null);



  const deleteDistrictMasterStatus = getStatus(state, apiKeys.deleteDistrictMaster, '');

  const onCloseAlert = useCallback(() => {
    setIsAlertDialog((prevState) => !prevState);
    setCurrentRowId(null);
  }, []);

  const onAgreeAlert = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.deleteDistrictMaster(currentRowId),
      method: apiMethods.DELETE,
      key: apiKeys.deleteDistrictMaster,
      successMsg: formatMessage({ id: "district-master-has-been-deleted-successfully" }),
      failureMsg: formatMessage({ id: "failed-to-delete-district-master" }),
    }))
    onCloseAlert();
  }, [dispatch, formatMessage, onCloseAlert, currentRowId]);


  const onRowDelete = useCallback((id) => {
    setCurrentRowId(id);
    setIsAlertDialog(true);
  }, []);



  useEffect(() => () => {
    dispatch(clearData({ key: apiKeys.deleteDistrictMaster }));
  }, [dispatch]);


  return useMemo(() => ({
    onRowDelete,
    deleteDistrictMasterStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,

  }), [
    onRowDelete,
    deleteDistrictMasterStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,
  ])
}
